import { render, staticRenderFns } from "./TokenAssignmentConfirmation.vue?vue&type=template&id=778cbe86&scoped=true"
import script from "./TokenAssignmentConfirmation.vue?vue&type=script&lang=js"
export * from "./TokenAssignmentConfirmation.vue?vue&type=script&lang=js"
import style0 from "./TokenAssignmentConfirmation.vue?vue&type=style&index=0&id=778cbe86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778cbe86",
  null
  
)

export default component.exports